import React from 'react';
import type { NearbyPlace } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';
import { useTranslation } from 'react-i18next';

interface NearbyPlaceRowProps {
  place: NearbyPlace;
  /** 1-based position — matches the numbered pin on the map above the list. */
  index?: number;
}

const NearbyPlaceRow: React.FC<NearbyPlaceRowProps> = ({ place, index }) => {
  const { t } = useTranslation();
  const canOpenMap = typeof place.map_url === 'string' && place.map_url.length > 0;
  const rating = (place as unknown as { rating?: unknown }).rating;
  const hasMeta =
    typeof place.walk_min === 'number' || typeof place.distance_m === 'number' || !!place.category;

  return (
    <div className="rc-nearby-row">
      {typeof index === 'number' && <span className="rc-nearby-index">{index}</span>}
      <div className="rc-nearby-body">
        <div className="rc-nearby-header">
          <span className="rc-nearby-name">{place.name}</span>
          {typeof rating === 'number' && (
            <span className="rc-nearby-rating">★ {rating.toFixed(1)}</span>
          )}
        </div>
        {hasMeta && (
          <div className="rc-nearby-meta">
            {typeof place.walk_min === 'number' && (
              <span className="rc-nearby-meta-text">
                {t('task.richContext.minuteWalk', { minutes: place.walk_min })}
              </span>
            )}
            {typeof place.distance_m === 'number' && (
              <span className="rc-nearby-meta-text">{place.distance_m} m</span>
            )}
            {!!place.category && (
              <span className="rc-nearby-meta-text rc-nearby-meta-text--category">
                {place.category}
              </span>
            )}
          </div>
        )}
      </div>
      {canOpenMap && (
        <button
          type="button"
          className="rc-map-button"
          onClick={() => window.open(place.map_url, '_blank', 'noopener,noreferrer')}
          aria-label={t('task.richContext.openMapFor', { name: place.name })}
        >
          <span className="rc-map-button-text">{t('task.richContext.open')}</span>
        </button>
      )}
    </div>
  );
};

export default NearbyPlaceRow;
